import { RatingAndReviewsUI } from "./RatingAndReviewsUI";
import { StandardProps } from "../componentMap";

export function RatingAndReviews({
  product,
  configProps,
}: Pick<StandardProps, "product" | "configProps">) {
  const { reviewSummary } = product;
  const hideRatings = configProps?.hideRatings === true;
  const suppressRatingLink = configProps?.suppressRatingLink === true;

  return (
    <RatingAndReviewsUI
      rating={
        reviewSummary && {
          averageRating: reviewSummary.averageRating,
          reviews: reviewSummary.numberOfReviews,
        }
      }
      hideRatings={hideRatings}
      suppressRatingLink={suppressRatingLink}
    />
  );
}
